import React, { Component } from "react";

const encode = (data) => {
  return Object.keys(data)
    .map((key) => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&");
};

class Contact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      email: "",
      subject: "",
      message: "",
    };
  }

  handleSubmit = (e) => {
    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({ "form-name": "contactForm", ...this.state }),
    })
      .then(() => alert("Success!"))
      .catch((error) => alert(error));

    e.preventDefault();
  };

  handleChange = (e) => this.setState({ [e.target.name]: e.target.value });

  render() {
    if (this.props.data) {
      var our_name = this.props.data.name;
      var our_street = this.props.data.address.street;
      var our_city = this.props.data.address.city;
      var our_state = this.props.data.address.state;
      var our_zip = this.props.data.address.zip;
      var our_email = this.props.data.email;
      var our_message = this.props.data.contactmessage;
    }
    const { name, email, subject, message } = this.state;

    return (
      <section id="contact">
        <div className="row section-head">
          <div className="two columns header-col">
            <h1>
              <span>Get In Touch.</span>
            </h1>
          </div>

          <div className="ten columns">
            <p className="lead">{our_message}</p>
          </div>
        </div>

        <div className="row">
          <div className="eight columns">
            <form
              id="contactForm"
              name="contactForm"
              onSubmit={this.handleSubmit}
            >
              <input type="hidden" name="form-name" value="contactForm" />
              <fieldset>
                <div>
                  <label htmlFor="contactName">
                    Name <span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    size="35"
                    id="contactName"
                    name="name"
                    value={name}
                    onChange={this.handleChange}
                  />
                </div>

                <div>
                  <label htmlFor="contactEmail">
                    Email <span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    size="35"
                    id="contactEmail"
                    name="email"
                    value={email}
                    onChange={this.handleChange}
                  />
                </div>

                <div>
                  <label htmlFor="contactSubject">Subject</label>
                  <input
                    type="text"
                    size="35"
                    id="contactSubject"
                    name="subject"
                    value={subject}
                    onChange={this.handleChange}
                  />
                </div>

                <div>
                  <label htmlFor="contactMessage">
                    Message <span className="required">*</span>
                  </label>
                  <textarea
                    cols="50"
                    rows="15"
                    id="contactMessage"
                    value={message}
                    name="message"
                    onChange={this.handleChange}
                  ></textarea>
                </div>

                <div>
                  <button className="submit">Submit</button>
                  <span id="image-loader">
                    <img alt="" src="images/loader.gif" />
                  </span>
                </div>
              </fieldset>
            </form>

            <div id="message-warning"> Error boy</div>
            <div id="message-success">
              <i className="fa fa-check"></i>Your message was sent, thank you!
              <br />
            </div>
          </div>

          <aside className="four columns footer-widgets">
            <div className="widget widget_contact">
              <h4>Address</h4>
              <p className="address">
                {our_name}
                <br />
                {our_street} <br />
                {our_city}, {our_state} {our_zip}
                <br />
                <span>{our_email}</span>
                <br />
              </p>
            </div>
          </aside>
        </div>
      </section>
    );
  }
}

export default Contact;
